import { ref } from 'vue'

export function maskCep (value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 5) return digits
  return `${digits.slice(0, 5)}-${digits.slice(5)}`
}

export function useCepLookup () {
  const loading = ref(false)
  const error = ref('')

  const fetchByCep = async (cepRaw) => {
    const cep = String(cepRaw || '').replace(/\D/g, '')
    error.value = ''
    if (cep.length !== 8) {
      error.value = 'invalid'
      return null
    }
    loading.value = true
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      const data = await response.json()
      if (data.erro) {
        error.value = 'notFound'
        return null
      }
      return {
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: (data.uf || '').toUpperCase()
      }
    } catch {
      error.value = 'network'
      return null
    } finally {
      loading.value = false
    }
  }

  return { loading, error, fetchByCep, maskCep }
}
